// extracted by mini-css-extract-plugin
export default {"wrapper":"ErrorCell__wrapper___bBkXJ","container":"ErrorCell__container____qnZy"};